import React from "react";
import '../../../Styles.css';
import {PublishOnKensuRequest, space} from "../../../../provider_api";
import {useProviderProfile} from "../../../../ProviderProfileProvider";
import './Publishing.css'
import {TabbedPageHeader} from "../../../../components/TabbedPageHeader";
import {getBookingHost} from "../../../../util/HostUtils";
import {getSubscriptionType} from "../../../../util/SubscriptionUtil";
import {Link} from "react-router-dom";
import {usePublishOnKensu} from "../../../../util/RpcHooks/usePublishOnKensu";
import BusinessSubscriptionType = space.kenko.proto.BusinessSubscriptionType;
import {profileIsReadyToPublish} from "../../WebsiteValidator";
import {LinkWithParams} from "../../../../util/NavUtils";
import {ActionButton} from "../../../../util/UI/ActionButton";


export const Publishing = () => {

  const {business} = useProviderProfile();

  if (!business?.published) {
    return <NonPublishedBusinesses/>;
  }

  return <PublishedBusinesses/>;
}

const PublishedBusinesses = () => {

  const {business} = useProviderProfile();
  const publishRpc = usePublishOnKensu();

  const unpublish = () => {
    if (window.confirm('Are you sure you want to unpublish your listing?')) {
      publishRpc.send(new PublishOnKensuRequest({publish: false}))
    }
  }

  return <div className={'NonScrollingToolPage'}>

    {/* There's no publish button since there are no drafts any more */}
    <TabbedPageHeader pageTitle={'Publishing'}/>

    <div className={'ProviderToolAreaContent'}>

      {publishRpc.rpcState.state == 'error' && <div className={'ErrorText'}>
        There was an error publishing your changes. Please try again.
      </div>}


      <div className={'GreenBanner'}>Your business is live on Kensu!</div>

      {publishRpc.rpcState.state == 'success' &&
          <div className={'PublishedBanner'}>
            Your changes have been published successfully.
          </div>}

      {business?.subscription?.type == BusinessSubscriptionType.LISTING_PLUS_BOOKING && <>
        <h2>Booking URL</h2>
        Your Kensu booking URL is:&nbsp;
        <Link style={{textDecoration: "underline", fontWeight: 400}}
              target={'_blank'}
              to={`${getBookingHost()}/book?b=${business?.businessId}`}>
          {getBookingHost()}/book?b={business?.businessId}
        </Link>
        <br/>
        <br/>
        To embed this link in your website, use the following snippet:

        <pre>
      <code>
      &lt;a href="{getBookingHost()}/book?b={business?.businessId}"&gt;Book on Kensu&lt;/a&gt;
      </code>
      </pre>
        <br/>
      </>}
      

      {getSubscriptionType(business) == BusinessSubscriptionType.LISTING_PLUS_BOOKING && <>
        <h2>Booking preview</h2>
        <a target={'_blank'} style={{textDecoration: 'underline', cursor: 'pointer'}}
           href={`${getBookingHost()}/book?b=${business?.businessId}&v=DRAFT`}>Preview your booking flow</a>
        <br/><br/>
        <div className={'InputHelpText'}>In order to fully preview your booking flow, make sure to add some
          availability blocks or classes to your calendar.
        </div>
      </>}
      <br/>

      <h2>Unpublish your listing</h2>
      <div>
        This will remove your business from Kensu search and disable your booking flow. Existing bookings will not be
        affected. Your membership will still remain active.
      </div>
      <br/>
      <div>
        <ActionButton secondary onClick={unpublish} rpcState={publishRpc.rpcState}>Unpublish</ActionButton>
      </div>

    </div>
  </div>
}

const NonPublishedBusinesses = () => {

  const publishRpc = usePublishOnKensu();
  const {business, businessProfile} = useProviderProfile();

  const sendPublishOnKensu = (published: boolean) => {
    publishRpc.send(new PublishOnKensuRequest({publish: published}))
  }

  const readyToPublish = profileIsReadyToPublish(business, businessProfile);

  return <div className={'NonScrollingToolPage'}>

    <TabbedPageHeader pageTitle={'Publishing'}
                      buttons={profileIsReadyToPublish(business, businessProfile) ? [{
                        text: 'Publish',
                        onClick: () => sendPublishOnKensu(true),
                        rpcState: publishRpc.rpcState
                      }] : undefined}
    />

    {publishRpc.rpcState.state == 'error' && <div className={'ErrorText'}>
      There was an error publishing your changes. Please try again.
    </div>}

    <div className={'ProviderToolAreaContent'}>
      <>
        {readyToPublish && <div>
          Your business is ready to go live on Kensu! Please click the "Publish" button
          when you are ready to launch!
        </div>}

        <h2>Profile completion</h2>

        {!readyToPublish && <div>
          Your profile requires additional setup before it can be published. Please
          visit the <LinkWithParams style={{textDecoration: 'underline'}} to={'/home'}>onboarding
          checklist.</LinkWithParams>
        </div>}

        {readyToPublish && <div>Your profile is complete.</div>}

        {business?.subscription?.type == BusinessSubscriptionType.LISTING_PLUS_BOOKING && <>
          <h2>Booking preview</h2>
          <a target={'_blank'} style={{textDecoration: 'underline', cursor: 'pointer'}}
             href={`${getBookingHost()}/book?b=${business?.businessId}&v=DRAFT`}>Preview your booking flow</a>
          <br/><br/>
          <div className={'InputHelpText'}>In order to fully preview your booking flow, make sure to add some
            availability blocks or classes to your calendar.
          </div>
        </>}
      </>
    </div>
  </div>;
}